import { BRAND_THEME, type BrandTheme } from "@/constants/theme";
import { create } from "zustand";

interface ThemeStore {
  routeTheme: BrandTheme;
  campaignTheme: BrandTheme;
  setRouteTheme: (theme: BrandTheme) => void;
  setCampaignTheme: (theme: BrandTheme) => void;
}

export const useThemeStore = create<ThemeStore>((set) => ({
  routeTheme: BRAND_THEME.DEFAULT,
  campaignTheme: BRAND_THEME.DEFAULT,
  setRouteTheme: (theme) => set({ routeTheme: theme }),
  setCampaignTheme: (theme) => set({ campaignTheme: theme }),
}));

/** Derived selector — routeTheme takes precedence over campaignTheme */
export const useActiveTheme = (): BrandTheme => {
  const { routeTheme, campaignTheme } = useThemeStore();
  return routeTheme !== BRAND_THEME.DEFAULT ? routeTheme : campaignTheme;
};
